var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['svg-icon' ,'qs-icon_'+_vm.iconClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }